import { c as _c } from "react/compiler-runtime";
import { IconCodeMedium } from "central-icons-outlined/IconCodeMedium";
import { IconReact } from "central-icons-outlined/IconReact";
import { IconTypescript } from "central-icons-outlined/IconTypescript";
import CssLogo from "@/icons/css-logo";
import { cn } from "@/lib/utils";
function getExtension(filename: string, language: string) {
  const dot = filename.lastIndexOf(".");
  return dot >= 0 ? filename.slice(dot + 1).toLowerCase() : language;
}
export function LanguageIcon(t0) {
  const $ = _c(16);
  const {
    filename,
    language,
    className
  } = t0;
  const extension = getExtension(filename, language);
  if (extension === "tsx" || extension === "jsx") {
    let t1;
    if ($[0] !== className) {
      t1 = cn("size-4 text-[#149eca]", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <IconReact className={t1} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (extension === "ts") {
    let t1;
    if ($[4] !== className) {
      t1 = cn("size-4 text-[#3178c6]", className);
      $[4] = className;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== t1) {
      t2 = <IconTypescript className={t1} />;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  if (extension === "css") {
    let t1;
    if ($[8] !== className) {
      t1 = cn("size-4", className);
      $[8] = className;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    let t2;
    if ($[10] !== t1) {
      t2 = <CssLogo className={t1} />;
      $[10] = t1;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    return t2;
  }
  let t1;
  if ($[12] !== className) {
    t1 = cn("size-4 text-gray-1000", className);
    $[12] = className;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== t1) {
    t2 = <IconCodeMedium className={t1} />;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}